import type { ProethicaTestKind } from "@constants/demo/proethica-tests";
import { useAppTheme } from "@hooks/useAppTheme";
import { Box } from "@memorang/ui";
import { Image } from "expo-image";
import { Avatar } from "react-native-paper";

const TEST_IMAGES: Record<ProethicaTestKind, number> = {
	pretest: require("../../../assets/praxis-proethica/modules/pretest-graphic-badge-transparent.png"),
	posttest: require("../../../assets/praxis-proethica/modules/posttest-graphic-badge-transparent.png"),
};

type Props = {
	kind: ProethicaTestKind;
	size?: number;
	locked?: boolean;
};

export const ProethicaTestBadge = ({ kind, size = 72, locked }: Props) => {
	const theme = useAppTheme();
	const lockIconSize = Math.max(20, Math.round(size * 0.4));

	return (
		<Box style={{ position: "relative", width: size, height: size }}>
			<Image
				source={TEST_IMAGES[kind]}
				style={{
					width: size,
					height: size,
					borderRadius: theme.roundness,
				}}
				contentFit="contain"
			/>
			{locked ? (
				<Box
					style={{
						position: "absolute",
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						justifyContent: "center",
						alignItems: "center",
						borderRadius: theme.roundness,
					}}
				>
					<Avatar.Icon
						size={lockIconSize}
						icon="lock-outline"
						style={{ backgroundColor: "transparent" }}
						color={theme.colors.onSurface}
					/>
				</Box>
			) : null}
		</Box>
	);
};
